namespace GeniuzPOS.Product {
    export interface CsSubCategory2Form {
        SubCat2Code: Serenity.StringEditor;
        SubCat2Name: Serenity.StringEditor;
    }

    export class CsSubCategory2Form extends Serenity.PrefixedContext {
        static formKey = 'Product.CsSubCategory2';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsSubCategory2Form.init)  {
                CsSubCategory2Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsSubCategory2Form, [
                    'SubCat2Code', w0,
                    'SubCat2Name', w0
                ]);
            }
        }
    }
}
